export const COMPANY_NAME = 'Sonocent'
export const MOBILE_BOUNDARY_WIDTH = 1425
